import * as Yup from 'yup';
import { notAllowedWord, reservedValues } from '../../common/formElements/reservedKeywords';
import { filterFieldOption } from '../collections/collection/derived-query/query-util';
import { FieldTypes } from 'drapcode-constant';

export const validationForFields = ({ xanoCustomName }) => {
  return Yup.object().shape({
    xanoCustomName: Yup.string()
      .required("Data Source Name can't be blank")
      .max(100, 'Name can not be more than 100 characters')
      .matches(/^[A-Za-z\s]+$/, 'Name should not contain special characters or numbers')
      .test('reserved', 'This is reserved word please use another', (value) => {
        const lowercaseValue = value ? value.toLowerCase() : '';
        return !reservedValues.includes(lowercaseValue);
      })
      .test('not-allowed', 'This type of word not allowed.', (value) => {
        const lowercaseValue = value ? value.toLowerCase() : '';
        return !notAllowedWord.includes(lowercaseValue);
      }),
    apiAccessToken: Yup.string().required("API Access Token can't be blank"),
  });
};

export const validationForSupabaseFields = ({ CustomName }) => {
  return Yup.object().shape({
    CustomName: Yup.string()
      .required("Data Source Name can't be blank")
      .max(100, 'Name can not be more than 100 characters')
      .matches(/^[A-Za-z\s]+$/, 'Name should not contain special characters or numbers')
      .test('reserved', 'This is reserved word please use another', (value) => {
        const lowercaseValue = value ? value.toLowerCase() : '';
        return !reservedValues.includes(lowercaseValue);
      })
      .test('not-allowed', 'This type of word not allowed.', (value) => {
        const lowercaseValue = value ? value.toLowerCase() : '';
        return !notAllowedWord.includes(lowercaseValue);
      }),
    developerKey: Yup.string().required("Anon Key can't be blank"),
    secretKey: Yup.string().required("Secret Key can't be blank"),
    dataBaseUrl: Yup.string().required("Project URL can't be blank"),
  });
};

export const extractFieldSupaBase = (data) => {
  const supabase = [];
  for (const tableName in data) {
    const fields = data[tableName].properties;
    const excludedFields = ['created_at', 'id'];
    const extractedFields = {};
    for (const fieldName in fields) {
      if (!excludedFields.includes(fieldName)) {
        extractedFields[fieldName] = fields[fieldName].format;
      }
    }
    supabase.push({ name: tableName, fields: extractedFields });
  }
  return supabase;
};

export const transformCollectionsAppwrite = (collections) => {
  return collections.map((collection) => ({
    collectionName: collection.name,
    collectionId: collection.$id,
    fields: collection.attributes.reduce((fields, attribute) => {
      switch (attribute.type) {
        case 'string':
          fields[attribute.key] = 'text';
          break;
        case 'integer':
          fields[attribute.key] = 'number';
          break;
        case 'datetime':
          fields[attribute.key] = 'date';
          break;
        default:
          fields[attribute.key] = attribute.type;
      }
      return fields;
    }, {}),
  }));
};

export const externalDBCollections = (collections) => {
  if (!collections || !collections.length) {
    return [];
  }

  const filteredCollections = collections.filter((collection) => collection.externalDatabaseId);
  return filteredCollections;
};

export const externalDBCollectionOptions = (collections) => {
  if (!collections || !collections.length) {
    return [];
  }
  let options = collections.map((item) => {
    return { value: item.collectionName, label: item.collectionTitle };
  });
  return options;
};

export const nonExternalDBCollections = (collections) => {
  if (!collections || !collections.length) {
    return [];
  }

  const filteredCollections = collections.filter((collection) => !collection.externalDatabaseId);
  return filteredCollections;
};

export const nonExternalDBCollectionOptions = (collections) => {
  if (!collections || !collections.length) {
    return [];
  }
  let options = collections.map((item) => {
    return { value: item.collectionName, label: item.collectionTitle };
  });
  return options;
};

export const createSelectOptionsForField = (fields) => {
  let selectOptions = [];
  selectOptions = filterFieldOption(
    fields,
    [
      FieldTypes.password.id,
      FieldTypes.file.id,
      FieldTypes.image.id,
      FieldTypes.multi_image.id,
      FieldTypes.video_link.id,
      FieldTypes.isDeleted.id,
      FieldTypes.createdAt.id,
      FieldTypes.updatedAt.id,
      FieldTypes.createdBy.id,
      FieldTypes.updatedBy.id,
      FieldTypes.version.id,
      FieldTypes.uuid.id,
    ],
    [],
  );
  return selectOptions;
};
